// extracted by mini-css-extract-plugin
module.exports = {"default":"c6e8ba5398--default--NLJo4","light":"c6e8ba5398--light--32T7I","outline":"c6e8ba5398--outline--2izsy"};